export default __webpack_public_path__ + "static/media/shop.a7e6d6e4.jpg";